import React from 'react';
import { Select, Button, Space, Tag, Tooltip } from 'antd';
import { FilterOutlined, ClearOutlined } from '@ant-design/icons';

const FilterHeader = ({
  selectedMetrics,
  childAdType,
  childCountries,
  selectedNetwork,
  metricsOptions,
  adTypeOptions,
  childCountryOptions,
  networkOptions,
  onMetricsChange,
  onAdTypeChange,
  onCountriesChange,
  onNetworkChange,
  onClearAll,
  onApplyFilter,
  isLoadingNetworks = false,
  appliedValues = {}
}) => {
  const getDisplayValue = (value, options) => {
    if (!value) return '';
    if (Array.isArray(value)) {
      return value.map(v => {
        const option = options.find(opt => opt.value === v);
        return option ? option.label : v;
      });
    }
    const option = options.find(opt => opt.value === value);
    return option ? option.label : value;
  };

  const renderFilterTag = (label, value, onClose) => {
    if (!value || (Array.isArray(value) && value.length === 0)) return null;
    
    const displayValue = Array.isArray(value) ? value.join(', ') : value;
    return (
      <Tag
        closable
        onClose={onClose}
        style={{ 
          margin: '2px 4px',
          borderRadius: '12px',
          background: '#f0f2f5',
          border: '1px solid #d9d9d9'
        }}
      >
        <strong>{label}:</strong> {displayValue}
      </Tag>
    );
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: '12px',
      padding: '8px 0'
    }}>
      {/* Left side - Filter tags */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        flexWrap: 'wrap',
        flex: 1,
        minWidth: 0,
        gap: '4px'
      }}>
        <span style={{ 
          marginRight: '8px', 
          fontWeight: 'bold',
          color: '#1890ff',
          fontSize: '14px'
        }}>
          <FilterOutlined style={{ marginRight: '4px' }} />
          Filters:
        </span>
        
        {renderFilterTag(
          'Metrics', 
          appliedValues.metrics || selectedMetrics, 
          () => onMetricsChange(undefined)
        )}
        
        {(appliedValues.metrics === 'imp_dau' || selectedMetrics === 'imp_dau' || appliedValues.metrics === 'ecpm' || selectedMetrics === 'ecpm') && renderFilterTag(
          'Ad Type', 
          appliedValues.adType || childAdType, 
          () => onAdTypeChange(undefined)
        )}
        
        {renderFilterTag(
          'Countries', 
          appliedValues.countries || childCountries, 
          () => onCountriesChange([])
        )}
        
        {renderFilterTag(
          'Networks', 
          appliedValues.networks || selectedNetwork, 
          () => onNetworkChange([])
        )}
      </div>

      {/* Right side - Filter controls */}
      <Space size="small" wrap>
        <Tooltip title="Clear all filters">
          <Button 
            icon={<ClearOutlined />} 
            onClick={onClearAll}
            size="small"
            type="text"
            danger
            style={{ 
              fontSize: '12px',
              height: '24px',
              padding: '0 8px'
            }}
          >
            Clear
          </Button>
        </Tooltip>
        
        <Button 
          type="primary" 
          onClick={onApplyFilter}
          size="small"
          style={{ 
            borderRadius: '6px',
            fontWeight: 'bold',
            fontSize: '12px',
            height: '24px',
            padding: '0 12px'
          }}
        >
          Apply
        </Button>
      </Space>
    </div>
  );
};

export default FilterHeader;
